<template>
	<md-dialog :md-closed="closeDialog"  class="hello-form-dialog" :md-close-on-esc="false"
	  :md-click-outside-to-close="false" :md-active.sync="options.showEditHelloForm">
    <md-dialog-title class="hello-title">
      <div class="hello-header">
          <div class="hello-title-wrapper">
            <span class="hello-title">
              {{ options.Lang.editHello }}
            </span>
          </div>
          <div class="hello-boxes">
            <div>
              <SmallInfoBox
                  v-if="tripAlias"
                  title="Angebot"
                  :content="tripAlias"
                  :copy="false"
              />
            </div>
            <div>
              <SmallInfoBox
                  v-if="trip && trip.nezasa_id"
                  title="Nezasa ID"
                  :content="trip.nezasa_id"
                  :copy="true"
              />
            </div>
          </div>
        </div>
      <!-- DIVIDER -->
      <div class="editor-divider"></div>
    </md-dialog-title>
    <md-dialog-content v-if="renderComponent">
      <div class="hello-container">
        <div class="language-section">
          <label class="section-label">{{ options.Lang.Sprache }}</label>
          <md-field class="md-focused">
            <md-select v-model="languageForm" class="select-language-field">
              <md-option v-for="(language, index) in languages" :key="'lang' + index" :value="language">
                {{ options.Lang.lang_code[language] }}
              </md-option>
            </md-select>
          </md-field>
          <md-field class="hide-price-field">
            <md-switch v-model="hidePriceInfo" class="md-primary"></md-switch>
            <span class="switch-label">{{ options.Lang.hidePriceInfo || 'Hide price information for this trip' }}</span>
          </md-field>
        </div>
        <!-- EDITORS -->
        <div class="editor-wrapper">
            <!-- LEFT EDITOR -->
          <div class="editor-box hello-editor">
            <div class="editor-header">
              <TextEditorWithHeader :options="options" :editor="editor" :label="`${options.Lang.editHelloLabel}<span style='color: red'>*</span>`" :model="currentHelloContent"/>
            </div>
          </div>
            <!-- RIGHT EDITOR -->
          <div class="editor-box hello-editor">
            <div class="editor-header">
              <TextEditorWithHeader :options="options" :editor="editor2" :label="`${options.Lang.editDocLabel}<span style='color: red'>*</span>`" :model="newDoc"/>
            </div>
          </div>
        </div>


        <!-- ERROR -->
        <Error
            v-if="options.showError && options.user.loggedIn"
            :options="options"
        />
      </div>
    </md-dialog-content>
    <div class="editor-divider"></div>
    <!-- BUTTONS -->
    <div class="hello-buttons">
      <md-button class="md-raised secondary" @click="closeDialog()">
        <strong>{{ options.Lang.Fenster_schließen }}</strong>
      </md-button>

      <md-button class="md-raised md-primary button-save" @click="saveFields">
        <strong>{{ options.Lang.Speichern }}</strong>
      </md-button>
    </div>
    <div v-if="options.showSuccessHtml" class="showMail md-elevation-10">
		<strong>E-mail</strong>
		<div class="email-container">
		  <div v-html="options.successMsgHtml"></div>
		</div>
		<div class="pr-30 center">
		  <md-button class="md-raised secondary" @click="closeDialog()"><strong>{{ options.Lang.Fenster_schließen }}</strong></md-button>
		</div>
	  </div>
	</md-dialog>
  </template>
  
  <script>
  import { validationMixin } from 'vuelidate'
  import Error from './Error.vue'

  import {Editor, EditorContent} from '@tiptap/vue-2'
  import Underline from '@tiptap/extension-underline'
  import StarterKit from '@tiptap/starter-kit'
  import Link from "@tiptap/extension-link";
  import TextEditorBox from '../basics/TextEditorBox.vue';
  import TextEditorWithHeader from '../parts/TextEditorWithHeader.vue';
  import SmallInfoBox from '../parts/SmallInfoBox.vue';

  export default {
	name: 'formTimeline',
	mixins: [validationMixin],
	components: {
	  Error,
	  EditorContent,
	  TextEditorBox,
    SmallInfoBox,
    TextEditorWithHeader
	},
	props: {
	  options: {
		type: Object,
		required: true
	  },
	  currentTrip: {
		type: Object
	  },
	},
	data: () => ({
	  trip: null,
	  brands:[],
	  sprache: null,
	  newHello: null,
	  globalHelloeng: null,
	  globalHello: null,
	  globalDocs: null,
    brandingLang: [],
	  newDoc: null,
	  helloEdit:null,
	  helloEditEng:null,
	  renderComponent: false,
	  mails: [],
	  supplier: "",
	  tripAlias: null,
	  languages: [],
	  languageForm:null,
	  hidePriceInfo: false,
	  editor: new Editor({
		content: '',
		extensions: [
		  StarterKit,
		  Underline,
		  Link.configure({
			openOnClick: false,
			})
		],
	  }),
	  editor2: new Editor({
		content: '',
		extensions: [
		  StarterKit,
		  Underline,
		  Link.configure({
			openOnClick: false,
			})
		],
	  }),
    testeditor: new Editor({
		content: '',
		extensions: [
		  StarterKit,
		  Underline,
		  Link.configure({
			openOnClick: false,
			})
		],
	  }),
	}),
	async mounted() {
	  this.trip = this.currentTrip;
    let trip_details = await this.loadJsonField('trip_details');
	  let test = trip_details;
	  this.tripAlias = test.data.attributes.alias;
	  await this.getModules();
	},
	watch: {
    languageForm(newVal, oldVal) {
      let data = { id: this.trip.nezasa_id, lang_code: newVal };
      this.doPost({ data: data }, "trip/languages", res => {
        if (res.status === "error") {
          return;
        }
        const currentlang = this.brandingLang.find(entry => entry.lang_code === newVal);
        if (currentlang) {
          this.globalHello = currentlang.hello;
          this.globalDocs = currentlang.infoDocs;
        }
        if (Array.isArray(res.data.data) && res.data.data.length === 0) {
          this.editor2.commands.setContent(this.globalDocs );
          this.editor.commands.setContent(this.globalHello);
          return;
        }
        if (res.data.data && res.data.data.length > 0) {
          const res_data = res.data.data[0];
          const texts = res_data.texts || {};

          const docContent = this.isEmpty(texts.saveDocMessage) ? this.globalDocs : texts.saveDocMessage;
          const helloContent = this.isEmpty(texts.saveHelloMessage) ? this.globalHello : texts.saveHelloMessage;
          this.editor2.commands.setContent(docContent);
          this.editor.commands.setContent(helloContent);
          this.hidePriceInfo = !!texts.hidePriceInfo;
        }
      });
    }

	},
	computed: {
		currentHelloContent: {
			get() {
			  return this.languageForm === 'de' ? this.helloEdit : this.helloEditEng;
			},
			set(value) {
        if (this.languageForm === 'de') {
          this.helloEdit = value;
        } else {
          this.helloEditEng = value;
        }
			}
		}
	},
	methods: {
    async loadJsonField(key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    isEmpty(val) {
      return  !val || val.trim() === '' || val.trim() === '<p></p>';
    },
	  async getModules(){
      let self = this;
      self.brands = []
      await self.doPost({}, 'getAllBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        result.forEach(element => {
          if(self.trip.Branding === element.adresse){
            self.trip.Branding = element.id;
          }
        })
        for(let i = 0; i < result.length; i++){
        self.brands.push(result[i])
        }
        self.getBrandName();
        self.getBrandingDefaults();
      }
      });
	  },
	  async getBrandName(){
      this.brands.forEach(brand =>{
        if(brand.adresse === "test"){
          this.trip.Branding = brand.id
        }
      })
	  },
    async getBrandingDefaults(){
      let myData = {
        id: this.trip.Branding,
      }
      let self = this;
      await self.doPost({data: myData}, 'getSingleBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        }else {

          let result = []
          if (res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
            result = res.data.data[0];
            self.brandingLang = res.data.data
            let default_lang = res.data.data[0].sprache
            const match = res.data.data.find(entry => entry.lang_code === default_lang);
            if (match) {
              result = match;
            }
          }else {
            return;
          }
          let tempArray = [];
          res.data.data.forEach(element => {
            tempArray.push(element.lang_code)
          })
          self.languages = tempArray
          self.globalDocs = result?.infoDocs || ''
          self.globalHello = result?.hello || '';
          self.sprache = result?.sprache || '';
          self.languageForm = !self.languageForm ? result?.sprache || 'de' : self.languageForm
          self.renderComponent = true;
        }
      });
	  },
    async saveFields(){
      let self = this;
      let saveHelloMessage = this.editor.getHTML()
      let saveDocMessage = this.editor2.getHTML()
      const langsToUpdate = Array.isArray(this.languages) && this.languages.length > 0
        ? this.languages
        : [this.languageForm];

      const saveForLang = (lang) => new Promise(resolve => {
        const isActive = lang === this.languageForm;
        const key = {
          hidePriceInfo: !!this.hidePriceInfo
        };
        if (isActive) {
          key.saveHelloMessage = saveHelloMessage;
          key.saveDocMessage = saveDocMessage;
        }
        const myData = {
          table: 'trip_languages',
          key,
          where: {
            nezasa_id : this.trip.nezasa_id,
            lang_code: lang
          },
          user_id : this.options.user.id,
        };
        self.doPost({data: myData}, 'table/add_field', res => resolve(res));
      });

      const results = await Promise.all(langsToUpdate.map(saveForLang));
      const ok = results.every(r => r && r.status === 'ok');
      if (ok) {
        self.options.showSuccess = true;
        self.$nextTick(() => {
          self.refreshDialog();
        });
      }
    },
	  closeDialog() {
      this.returnToBrandName();
      this.options.showEditHelloForm = false;
      this.options.showSuccessHtml = false;
      this.options.currentTrip = null;
	  },
	  returnToBrandName() {
		this.brands.forEach(brand =>{
			if(brand.id === this.options.currentTrip.Branding){
				this.options.currentTrip.Branding = brand.adresse
			}
		  })
	  },
	  refreshDialog() {
      let saveHelloMessage = this.editor.getHTML()
      let saveDocMessage = this.editor2.getHTML()
      const docContent = this.isEmpty(saveDocMessage) ? this.globalDocs : saveDocMessage;
      const helloContent = this.isEmpty(saveHelloMessage) ? this.globalHello : saveHelloMessage;

      this.editor2.commands.setContent(docContent);
      this.editor.commands.setContent(helloContent);
	  },
	}
}
</script>
  <style lang="scss">
  @use '../../assets/style/FormAddKommentar/tab_layout.scss';
  .hello-form-dialog .md-dialog-container{
    max-width: 1500px !important;
    width: 1500px !important;

    margin: 0 auto;
    border-radius: 12px;
  }

  .md-dialog-content{
    padding: 0 !important;
  }
  
  #divEmail{
	background: white;
	width: 107%;
	padding: 3rem;
	margin-left: -3rem;
	padding-bottom: 1rem;
	margin-top: -5rem;
  }

  .container {
	padding: 30px;
  }
  
  .select-language {
	margin-top: 10px;
  }

  .select-select-language {
	height: 57px !important;
  }
  
  .showMail {
	position: absolute;
	left: 15%;
	min-width: 780px;
	max-width: 780px;
	margin: 0 auto;
	height: 100%;
	padding-left: 40px;
	padding-right: 40px;
	overflow-y: auto;
	background-color: white;
	border: 30px solid #8FA1B4;
	z-index: 33;
  }
  
  .email-container {
	background-color: #F5F6FA;
	padding: 18px;
	margin-top: 10px;
	margin-bottom: 70px;
	border: 0.6000000238418579px solid #D5D5D5;
  }
  
  .tableclass {
	width: 100%;
	min-height: 70px;
	padding: 5px 5px;
	vertical-align: bottom;
	border-collapse: collapse;
  }
  
  .tableclass:hover {
	cursor: inherit;
  }
  
  .pointer:hover {
	cursor: pointer;
  }
  
  .tableclass2-timeline {
	width: 100%;
	height: 48px;
	padding-left: 50px;
	vertical-align: center !important;
	border-collapse: collapse;
	background: #E1E8F3;
	opacity: 1;
  
	font-weight: bold;
	border-radius: 10px;
  }
  
  .tableclass td {
	padding: 5px;
	vertical-align: center;
	padding-top: 20px !important;
	padding-bottom: 15px !important;
  }
  
  .tableclass2-timeline td {
	padding: 5px 15px 5px -5px;
	vertical-align: center !important;
  }
  
  .tableclass tr {
	padding: 5px;
	background-color: white !important;
	border-bottom: 0.4000000059604645px solid #97979767;
  }
  
  .spacer {
	background-color: white;
	height: 5px;
  }
  
  .name {
	width: 11% !important;
  }
  
  .date {
	width: 13% !important;
  }
  
  .trip-details {
	width: 27%;
  }
  
  .address1 {
	width: 18% !important;
  }
  
  .address2 {
	width: 20%;
  }
  
  .cc {
	width: 15%;
  }
  
  .prev {
	width: 10%;
	visibility: hidden;
  }
  
  .minH {
	min-height: 50px;
  }
  
  .none {
	display: none;
  }
  
  .formTD {
	background-color: rgb(249, 249, 249);
	margin-bottom: 5px;
  }
  
  .lds-ring {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
  }
  
  .lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 64px;
	height: 64px;
	margin: 8px;
	border: 8px solid #B6D210;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #B6D210 transparent transparent transparent;
  }
  
  .lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
  }
  
  .lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
  }
  
  .lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
  }
  
  @keyframes lds-ring {
	0% {
	  transform: rotate(0deg);
	}
  
	100% {
	  transform: rotate(360deg);
	}
  }
  
  .loading_spinner {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 100000000000;
	background-color: rgba(255, 255, 255, 0.8);
	backdrop-filter: blur(4px);
	-webkit-backdrop-filter: blur(4px);
  }
  
  .catTR td {
	background-color: white;
  }
  
  .label-container {
	display: flex;
	flex-wrap: wrap;
  }
  
  .label-left,
  .label-right {
	display: flex;
	flex-direction: column;
  }
  
  .label-left {
	margin-right: 0px;
  }
  
  .label-text {
	font-weight: bold;
	margin-bottom: 10px;
  }
  
  .trip-alias {
	min-width: 740px;
  }
  
  .nezasa-id {
	min-width: 265px;
  }
  
  .nezasa-id,
  .trip-alias {
	border: 0.6000000238418579px solid #D5D5D5;
	border-radius: 4px;
	background: #F5F6FA 0% 0% no-repeat padding-box;
	padding: 18px;
	margin-bottom: 15px;
  }
  
  .asterix {
	color: #EA7C7C;
  }
  .blubbi.hello1 .ProseMirror{
	min-height: 15rem !important;
	max-height: 15rem !important;
	min-width: 31rem !important;
	max-width: 31rem !important;
  }
  .blubbi.hello2 .ProseMirror{
	min-height: 15rem !important;
	max-height: 15rem !important;
	min-width: 31rem !important;
	max-width: 31rem !important;
  }
  /* HEADER ROW */
  .hello-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50px
  }

  .hello-title {
    font-size: 2rem !important;
    margin: 0 !important;
  }

  /* BOXES RIGHT SIDE */
  .hello-boxes {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  /* SPRACHE ROW */
  .language-row {
    margin-top: 40px;
    margin-bottom: 30px;
    width: 280px;
  }

  /* LABELS ABOVE EDITORS */
  .editor-labels {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-right: 30px;
  }

  .hello-label {
    margin-left: 5px;
  }

  .doc-label {
    margin-right: 28%;
  }

  /* TWO EDITORS SIDE-BY-SIDE */
  .editors-row {
    display: flex;
    gap: 20px;
  }

  .editor-block {
    width: 50%;
  }

  /* Main container */
  .hello-container {

    position: relative;
  }
  .hello-title {
    font-size: 30px !important;
    font-weight: 500 !important;
  }

  /* Sprache section */
  .language-section {
    margin-top: 40px;
    width: 100%;
    padding: 0 50px;
  }

  .section-label {
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
    font-size: 15px;
  }

  .select-language-field {
    background: #F5F6FA !important;
    border-radius: 8px !important;
    height: 54px !important;
  }

  .hide-price-field {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .hide-price-field .switch-label {
    font-weight: 500;
  }

  /* Editor titles above both editors */
  .editor-title-row {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 10px;
    padding-right: 30px;
  }

  .editor-label {
    font-weight: 600;
  }

  /* Two editor boxes */
  .editor-wrapper {
    display: flex;
    gap: 30px;
    margin-bottom: 40px;
    margin-top: 20px;
    padding: 0 50px;
  }

  /* Editor grey background */
  .editor-content-box {
    background: #F5F6FA;
    border: 1px solid #D5D5D5;
    min-height: 380px;
    padding: 20px !important;
  }
  .ProseMirror {
    max-height: min-content !important;
  }
  /* Divider line under editors */
  .editor-divider {
    width: 100%;
    border-top: 1px solid #ECECEC;
    margin: 5px 0 5px 0;
  }

  /* Buttons row */
  .hello-buttons {
    display: flex;
    justify-content: space-between;
    padding: 20px 50px 20px 50px;
  }
.editor-header{
  padding-top: 50px;
  padding-bottom: 10px;
}
  /* hide default SVG arrow */
  .select-language-field.md-menu.md-select > .md-icon svg {
    display: none !important;
  }

  /* show custom arrow instead */
  .select-language-field.md-menu.md-select > .md-icon.md-icon-image {
    background-image: url('@/assets/images/icons/arrow-down.svg') !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: 16px !important;
    width: 24px !important;
    height: 24px !important;
    color: transparent !important;
  }
  .editor-box {
    width: 100%;
  }
  .hello-editor{
    padding-right: 0 !important;
  }
  .md-field {
    width: 100% !important;
  }
  </style>
  